var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.extended ? _c('button', {
    staticClass: "font-medium items-center inline-flex",
    class: ['text-gray-900', 'text-md', 'border border-indigo-200', 'bg-white hover:bg-indigo-50 focus:bg-indigo-50', 'h-12', 'rounded-xl', 'px-4 py-3', 'gap-2'],
    attrs: {
      "aria-expanded": _vm.extended,
      "title": "Synthèse vocale"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.extendAndPlay.apply(null, arguments);
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.extendAndPlay.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.extendAndPlay.apply(null, arguments);
      }]
    }
  }, [_c('span', {
    staticClass: "relative"
  }, [_c('Icon', {
    staticClass: "fill-indigo-600 h-5 w-5",
    attrs: {
      "name": "volume-high",
      "aria-hidden": true
    }
  })], 1), _vm._v(" "), !_vm.$isMobile ? _c('span', {
    staticClass: "md:hidden text-sm"
  }, [_vm._v("Écouter la question")]) : _vm._e()]) : _c('div', {
    staticClass: "relative flex items-center",
    class: ['border border-indigo-200', 'bg-white hover:bg-indigo-50 focus:bg-indigo-50', 'rounded-xl', 'px-4 py-3', 'gap-2']
  }, [_vm.withBars ? _c('div', {
    staticClass: "absolute top-0 right-0 h-5 transform translate-x-1/2 -translate-y-1/2"
  }, [_c('button', {
    class: ['text-gray-900', 'text-md', 'border border-indigo-100', 'bg-white hover:bg-indigo-50 focus:bg-indigo-50', 'h-5 w-5', 'rounded-full', 'p-1'],
    attrs: {
      "aria-label": "Fermer"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.extended = false;
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.stopPropagation();
        $event.preventDefault();
        _vm.extended = false;
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.stopPropagation();
        $event.preventDefault();
        _vm.extended = false;
      }]
    }
  }, [_c('Icon', {
    staticClass: "fill-white text-red-700",
    attrs: {
      "name": "close"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "font-medium items-center inline-flex",
    class: ['text-gray-900', 'text-md', 'bg-white hover:bg-indigo-50 focus:bg-indigo-50', 'h-5', 'rounded-full', 'gap-2'],
    attrs: {
      "title": _vm.state === 'notplaying' || _vm.state === 'paused' ? 'Lecture' : 'Pause'
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.play.apply(null, arguments);
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.play.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.play.apply(null, arguments);
      }]
    }
  }, [_c('span', {
    staticClass: "relative"
  }, [_vm.state === 'playing' ? _c('Icon', {
    staticClass: "h-5 w-5",
    attrs: {
      "name": "hourglass"
    }
  }) : _c('Icon', {
    staticClass: "h-5 w-5",
    attrs: {
      "name": "play-circle"
    }
  })], 1), _vm._v(" "), _vm.withBars ? _c('span', {
    staticClass: "flex gap-1.5 h-full items-center"
  }, _vm._l(18, function (n) {
    return _c('span', {
      key: n,
      staticClass: "w-1 rounded-md text-xs transition-all duration-100",
      class: `${_vm.waveFormColor(n)}`,
      style: `height: ${_vm.bars[n - 1]}%`
    });
  }), 0) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }